<template>
  <div class="image-box">
    <div v-if="file" class="image-field">
      <img
        :src="file.thumbnail_link ?? file.link"
        alt=""
        @click.prevent="showImage"
      >
      <div class="image-box__buttons">
        <b-btn
          variant="danger"
          size="xs"
          @click.prevent="deleteImage"
        >
          Delete
        </b-btn>
      </div>
    </div>
    <div v-else-if="isLoading" class="busy-field">
      Loading..
    </div>
    <div
      v-else
      class="upload-field text-xl"
      :class="{ 'upload-field__dragging': isDragging }"
      @click="selectImage"
      @dragover="onDragOver"
      @dragleave="onDragLeave"
      @drop="onDrop"
    >
      <i class="fas fa-upload"></i>
      <input
        ref="file"
        type="file"
        :disabled="isLoading"
        @change="uploadImage()"
        accept="image/*"
        class="input-file hidden"
      >
    </div>
  </div>
</template>

<script>
import { popWindow } from '@/helpers';

export default {
  name: 'ImageBox',
  components: {},
  props: {
    upload: null,
    data: Object,
    field: String,
  },
  computed: {
    isLoading() {
      return this.loadingCount > 0;
    },
    fieldValue() {
      return this.data[this.field];
    },
  },
  data() {
    return {
      loadingCount: 0,
      file: null,
      isDragging: false,
    };
  },
  methods: {
    fetchImage() {
      if (this.fieldValue === null) {
        return;
      }
      this.loadingCount++;
      this.$http
        .get(`/files/${this.fieldValue}`)
        .then((res) => {
          this.file = res.body.file;
        })
        .catch((err) => {
          alert(`Failed to fetch file: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    showImage() {
      popWindow(this.file.link);
    },
    deleteImage() {
      if (!confirm('Do you really wish to delete this image?')) {
        return;
      }
      this.data[this.field] = null;
      this.file = null;
    },
    selectImage() {
      this.$refs.file.click();
    },
    uploadImage() {
      const file = this.$refs.file.files[0];
      if (!file) {
        return;
      }
      if (!file.type.startsWith('image')) {
        this.$toast.error(`${file.name} is not an image!`);
        return;
      }
      const formData = new FormData();
      formData.append('file', file);
      formData.append('mtime', file.lastModified / 1000);
      this.$http
        .post('/files')
        .send(formData)
        .then((res) => {
          this.data[this.field] = res.body.file.id;
          this.file = res.body.file;
        })
        .catch((err) => {
          this.$toast.error(`Failed to upload file: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    onDragOver(event) {
      event.preventDefault();
      this.isDragging = true;
    },
    onDragLeave() {
      this.isDragging = false;
    },
    onDrop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.isDragging = false;
      this.uploadImage();
    },
  },
  created() {
    this.fetchImage();
  },
  watch: {
    'data.image_file_id': {
      handler() {
        if (this.file === null || this.fieldValue !== this.file.id) {
          this.fetchImage();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.image-box {
  position: relative;
  width: 100%;
  // height: 100%;
  aspect-ratio: 3 / 4;

  &:hover {
    cursor: pointer;
  }

  .upload-field:hover, .upload-field__dragging {
    background-color: #efefef;
  }

  .image-field {
    width: 100%;
    height: 100%;
  }

  .busy-field {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border: 1px solid #ccc;
  }

  .upload-field {
    position: relative;;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border: 2px dashed #ccc;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-height: -webkit-fill-available;
  }

  &:hover .image-box__buttons {
    display: block;
  }
}

.image-box__buttons {
  display: none;
  position: absolute;
  right: 6px;
  top: 6px;
}
</style>
